var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { attrs: { "data-vv-scope": "data-group" } }, [
    _c("div", { staticClass: "row mb-5" }, [
      _c("div", { staticClass: "col-md-12 mt-3 text-center" }, [
        !_vm.showConfirm && !_vm.confirm
          ? _c(
              "div",
              [
                !_vm.group.isOffice
                  ? _c("p", { staticClass: "warning-confirmation" }, [
                      _vm._v(
                        " ¿Estás seguro de remover el grupo " +
                          _vm._s(_vm.group.nombre) +
                          "? "
                      )
                    ])
                  : _vm._e(),
                _vm.group.isOffice
                  ? _c("p", { staticClass: "warning-confirmation" }, [
                      _vm._v(
                        " ¿Estás seguro de remover la oficina " +
                          _vm._s(_vm.group.nombre) +
                          "? "
                      )
                    ])
                  : _vm._e(),
                _c(
                  "b-button",
                  {
                    attrs: { variant: "primary", "data-cy": "remove" },
                    on: {
                      click: function($event) {
                        return _vm.attemptRemoveGroup()
                      }
                    }
                  },
                  [_vm._v(" Remover ")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm.showConfirm
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-6" }, [
                !_vm.group.isOffice
                  ? _c("p", { staticClass: "warning-confirmation" }, [
                      _vm._v(
                        " Vas a remover el grupo " +
                          _vm._s(_vm.group.nombre) +
                          " "
                      )
                    ])
                  : _vm._e(),
                _vm.group.isOffice
                  ? _c("p", { staticClass: "warning-confirmation" }, [
                      _vm._v(
                        " Vas a remover la oficina " +
                          _vm._s(_vm.group.nombre) +
                          " "
                      )
                    ])
                  : _vm._e()
              ]),
              _c("div", { staticClass: "col-6" }, [
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "ml-3",
                        attrs: { variant: "outline-secondary" },
                        on: {
                          click: function($event) {
                            return _vm.discardChanges()
                          }
                        }
                      },
                      [_vm._v(" Mejor no ")]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "ml-3",
                        attrs: { variant: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.saveChanges()
                          }
                        }
                      },
                      [_vm._v(" Si, seguro ")]
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }